import { render } from "./LifecycleStages.vue?vue&type=template&id=2d4f30eb&scoped=true"
import script from "./LifecycleStages.vue?vue&type=script&lang=js"
export * from "./LifecycleStages.vue?vue&type=script&lang=js"

import "./LifecycleStages.vue?vue&type=style&index=0&id=2d4f30eb&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4f30eb"]])

export default __exports__